<template>
  <div class="container">
    <vs-card title="Modelos de Riesgo">
      <vs-table :data="rules">
        <template slot="thead">
          <vs-th>Indicadores</vs-th>
          <vs-th>Peso indicador</vs-th>
          <vs-th>Tipo de análisis</vs-th>
          <vs-th>Limite inferior</vs-th>
          <vs-th>Limite superior</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr v-for="rule in data" :key="`trx-${rule.identity_name}`">
            <vs-td><strong>{{rule.name}} ({{rule.identity_name}})</strong></vs-td>
            <vs-td>
              <edit-text-component
                v-model="rule.weight"
                @keyup.enter.native="updateWeight()" /> %
            </vs-td>
            <vs-td>{{rule.analysis_type.type}}</vs-td>
            <vs-td>
              <edit-text-component
                v-model="rule.worst_value"
                @keyup.enter.native="updateWorstValue()"/>
            </vs-td>
            <vs-td>
              <edit-text-component
                v-model="rule.best_value"
                @keyup.enter.native="updateBestValue()"/>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-card>
  </div>
</template>

<script>
import {RiskModel} from "@/services/ModelRisk/RiskModel";
import EditTextComponent from "@components/editText/EditTextComponent";

export default {
  name: "Versions",
  components: {EditTextComponent},
  data: () => ({
    rules: []
  }),
  async mounted() {
    let groupId = this.$route.params.groupId;
    this.$vs.loading();

    try {
      this.rules = await RiskModel.admin()
        .rules()
        .getByGroupId(groupId);
    } finally {
      this.$vs.loading.close();
    }
  },
  methods: {
    updateWeight() {
      alert("Actualizando peso del indicador")
    },
    updateWorstValue() {
      alert("Actualizando peor puntaje")
    },
    updateBestValue() {
      alert("Actualizando mejor puntaje")
    }
  }
}
</script>

<style scoped>

</style>
